import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "context/TranslationProvider";
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import "select2/dist/css/select2.min.css";
import userServices from "services/userServices";
import { useNotification } from "providers/NotificationProvider";

const RoleModal = ({ ticket, onClose, onAssigned }) => {
  const [roles, setRoles] = useState([]);
  const [assignedTo, setAssignedTo] = useState("");
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const modalBodyRef = useRef(null);
  const { notify } = useNotification();
  const notifyRef = useRef(notify);

  useEffect(() => {
    const getAllRoles = async () => {
      try {
        const res = await userServices.getAllRoles();
        const rolesList = res?.data?.roles || (Array.isArray(res?.data) ? res?.data : res?.roles) || [];
        if (rolesList) {
          setRoles(rolesList);

          if (ticket?.role) {
            const currentRole = rolesList.find(
              (role) => role._id === ticket.role || role.name === ticket.role
            );
            if (currentRole) setAssignedTo(currentRole._id);
          }
        } else {
          notifyRef.current("error", "Failed to load roles");
        }
      } catch (error) {
        console.error(error);
        notifyRef.current("error", "Failed to load roles");
      }
    };

    getAllRoles();
  }, [ticket, notify]);

  const handleAssign = async () => {
    if (!assignedTo) {
      notify("error", "Please select a role");
      return;
    }

    setLoading(true);
    try {
      const payload = { role: assignedTo };

      const res = await userServices.updateUserDetails(ticket._id, payload);
      console.log(res);

      if (res?.statusText === "OK") {
        notify("success", "Role assigned");
        const assignedRole = roles.find((role) => role._id === assignedTo) || null;
        onAssigned(assignedRole);
        onClose();
      } else {
        notify("error", res?.error || "Assignment failed");
      }
    } catch (error) {
      console.error(error);
      notify("error", "Assignment failed");
    } finally {
      setLoading(false);
    }
  };

  const options = [
    { id: "", text: t("modal.assignRole.selectRole", "Select role") },
    ...roles.map((role) => ({ id: role._id, text: t(`table.row.${role.slug}`) })),
  ];

  return (
    <>
      <ModalHeader toggle={onClose} className="border">
        {t("modal.assignRole.title", "Assign Role")}
      </ModalHeader>

      <ModalBody ref={modalBodyRef}>
        <Select2
          className="form-control"
          value={assignedTo}
          onChange={(e) => setAssignedTo(e.target.value)}
          options={{
            width: "100%",
            dropdownParent: modalBodyRef.current,
            data: options,
          }}
        />
      </ModalBody>

      <ModalFooter className="border">
        <Button color="secondary" onClick={onClose}>
          {t("common.cancel", "Cancel")}
        </Button>
        <Button color="warning" onClick={handleAssign} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              {t("button.assign", "Assign")}
            </>
          ) : (
            t("button.assign", "Assign")
          )}
        </Button>
      </ModalFooter>
    </>
  );
};

export default RoleModal;
